module.exports = require("react-redux");


/*****************
 ** WEBPACK FOOTER
 ** external "react-redux"
 ** module id = 42
 ** module chunks = 0
 **/